module.exports = __webpack_public_path__ + "img/tutor.079299ff.svg";